import * as React from 'react';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import OutlinedFunnel from 'acud-icon/lib/icons/OutlinedFunnel';
import cloneDeep from 'lodash/cloneDeep';
import Button from '../../../button';
import Tree from '../../../tree';
import Checkbox from '../../../checkbox';
import Dropdown from '../../../dropdown';
import Empty from '../../../empty';
import FilterDropdownMenuWrapper from './FilterWrapper';
import FilterSearch from './FilterSearch';
import { flattenKeys } from '.';
import useSyncState from '../../../_util/hooks/useSyncState';
import { ConfigContext } from '../../../config-provider/context';
const defaultFilterFun = (searchValue, filterItem) => { var _a; return ((_a = filterItem.text) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().indexOf(searchValue.trim().toLowerCase())) > -1; };
function searchValueMatched(searchValue, text) {
    if (typeof text === 'string' || typeof text === 'number') {
        return text === null || text === void 0 ? void 0 : text.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
    }
    return false;
}
const formatContent = (content, searchValue, prefixCls) => {
    const lowerContent = content.toLowerCase();
    const lowerSearch = searchValue.toLowerCase().trim();
    const searchStartIndex = lowerContent.indexOf(lowerSearch);
    const len = lowerSearch.length;
    // 存在搜索值不在content的情况，比如key与children不一致时
    if (searchStartIndex === -1) {
        return <>{content}</>;
    }
    return (<>
        {content.slice(0, searchStartIndex)}
        <span className={`${prefixCls}-dropdown-search-highlight`}>
            {content.slice(searchStartIndex, searchStartIndex + len)}
        </span>
        {content.slice(searchStartIndex + len)}
    </>);
};
function FilterDropdown(props) {
    var _a;
    const { tablePrefixCls, prefixCls, column, dropdownPrefixCls, columnKey, filterMultiple, filterMode = 'menu', filterSearch = false, filterState, filterShowSelectAll, triggerFilter, locale, children, getPopupContainer } = props;
    const { filterDropdownVisible, filterPlaceholder, onFilterDropdownVisibleChange } = column;
    const [visible, setVisible] = React.useState(false);
    const filtered = !!(filterState && (((_a = filterState.filteredKeys) === null || _a === void 0 ? void 0 : _a.length) || filterState.forceFiltered));
    const triggerVisible = (newVisible) => {
        setVisible(newVisible);
        onFilterDropdownVisibleChange === null || onFilterDropdownVisibleChange === void 0 ? void 0 : onFilterDropdownVisibleChange(newVisible);
    };
    const mergedVisible = typeof filterDropdownVisible === 'boolean' ? filterDropdownVisible : visible;
    // ===================== Select Keys =====================
    const propFilteredKeys = filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys;
    // preKeys = propFilteredKeys;
    const [getFilteredKeysSync, setFilteredKeysSync] = useSyncState(propFilteredKeys || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onSelectKeys = React.useCallback(({ selectedKeys }) => {
        setFilteredKeysSync(selectedKeys);
    }, []);
    const onCheck = (keys, { node, checked }) => {
        if (!filterMultiple) {
            onSelectKeys({ selectedKeys: checked && node.key ? [node.key] : [] });
        }
        else {
            onSelectKeys({ selectedKeys: keys });
        }
    };
    const menuChange = (e, value) => {
        const keys = new Set(getFilteredKeysSync());
        const checked = e.target.checked;
        checked ? keys.add(value) : keys.delete(value);
        onSelectKeys({ selectedKeys: [...keys] });
    };
    React.useEffect(() => {
        if (!visible) {
            return;
        }
        onSelectKeys({ selectedKeys: propFilteredKeys || [] });
    }, [propFilteredKeys, visible]);
    // search in tree mode column filter
    const [searchValue, setSearchValue] = React.useState('');
    const onSearch = (e) => {
        const { value } = e.target;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    React.useEffect(() => {
        if (!visible) {
            setSearchValue('');
        }
    }, [visible]);
    const filteredArr = React.useMemo(() => {
        if (searchValue === '' || searchValue === undefined) {
            return column.filters;
        }
        if (filterMode === 'tree') {
            const loopTree = (arr) => {
                const filteredArrTemp = [];
                arr.forEach(filterItem => {
                    var _a;
                    if (defaultFilterFun(searchValue, filterItem)) {
                        filteredArrTemp.push(filterItem);
                    }
                    else if (((_a = filterItem === null || filterItem === void 0 ? void 0 : filterItem.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        const tempArr = loopTree(filterItem.children);
                        if (tempArr.length > 0) {
                            filterItem.children = tempArr;
                            filteredArrTemp.push(filterItem);
                        }
                    }
                });
                return filteredArrTemp;
            };
            return loopTree(cloneDeep(column.filters));
        }
        return column.filters.filter(filterItem => defaultFilterFun(searchValue, filterItem));
    }, [filterMode, column.filters, searchValue]);
    // ======================= Submit ========================
    const internalTriggerFilter = (keys) => {
        const mergedKeys = keys && keys.length ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) {
            return null;
        }
        if (isEqual(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys)) {
            return null;
        }
        triggerFilter({
            column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    const onConfirm = () => {
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onReset = () => {
        setSearchValue('');
        setFilteredKeysSync([]);
        // internalTriggerFilter([]);
        // triggerVisible(false);
    };
    const doFilter = ({ closeDropdown } = { closeDropdown: true }) => {
        if (closeDropdown) {
            triggerVisible(false);
        }
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onVisibleChange = (newVisible) => {
        if (newVisible && propFilteredKeys !== undefined) {
            // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefiend)
            setFilteredKeysSync(propFilteredKeys || []);
        }
        // Default will filter when closed
        if (!newVisible && !column.filterDropdown) {
            // onConfirm();
            onReset();
        }
        triggerVisible(newVisible);
    };
    // ======================== Style ========================
    const onCheckAll = (e) => {
        const selectedKeys = (getFilteredKeysSync() || []);
        // const allFilterKeys = flattenKeys(filteredArr).map(key => String(key));
        const allFilterKeys = flattenKeys(filteredArr);
        if (e.target.checked) {
            setFilteredKeysSync([...new Set([...selectedKeys, ...allFilterKeys])]);
        }
        else {
            setFilteredKeysSync(selectedKeys.filter(key => !allFilterKeys.includes(key)));
        }
    };
    const onClearAll = () => {
        setFilteredKeysSync([]);
        onConfirm();
    };
    const onSingleCheck = value => {
        setFilteredKeysSync([value]);
        onConfirm();
    };
    const getTreeChildrenData = ({ filters }) => {
        return (filters || []).map((filter, index) => {
            const key = String(filter.value);
            const item = {
                title: filter.text,
                key: filter.value !== undefined ? key : index
            };
            if (filter.children) {
                item.children = getTreeChildrenData({ filters: filter.children });
            }
            return item;
        });
    };
    const getTreeData = ({ filters }) => {
        const treeDataArr = [];
        const treeData = {
            title: locale.filterCheckall,
            key: 'checkall',
            children: []
        };
        treeData.children = getTreeChildrenData({ filters });
        treeDataArr.push(treeData);
        return treeDataArr;
    };
    let dropdownContent;
    if (typeof column.filterDropdown === 'function') {
        dropdownContent = column.filterDropdown({
            prefixCls: `${dropdownPrefixCls}-custom`,
            setSelectedKeys: (selectedKeys) => onSelectKeys({ selectedKeys }),
            selectedKeys: getFilteredKeysSync(),
            confirm: doFilter,
            clearFilters: onReset,
            filters: column.filters,
            visible: mergedVisible
        });
    }
    else if (column.filterDropdown) {
        dropdownContent = column.filterDropdown;
    }
    else {
        const selectedKeys = (getFilteredKeysSync() || []);
        const getFilterComponent = () => {
            if (filteredArr.length === 0) {
                return (<Empty className={`${tablePrefixCls}-filter-dropdown-empty`} description={locale.filterEmptyText} hasImage={false}/>);
            }
            if (filterMode === 'tree') {
                return (<>
                        <div className={`${tablePrefixCls}-filter-dropdown-tree`}>
                            <Tree checkable selectable={false} multiple={filterMultiple} checkStrictly={!filterMultiple} className={`${dropdownPrefixCls}-menu`} onCheck={onCheck} checkedKeys={selectedKeys} selectedKeys={selectedKeys} searchable={filterSearch !== false} showIcon={false} treeData={getTreeData({ filters: filteredArr })} autoExpandParent defaultExpandAll filterTreeNode={searchValue.trim()
                        ? node => searchValueMatched(searchValue, node.title)
                        : undefined}/>
                        </div>
                    </>);
            }
            return (<>
                    <div className={`${dropdownPrefixCls}-menu`}>
                        {filterMultiple && <>
                            {filterShowSelectAll
                        && (<div className={`${dropdownPrefixCls}-menu-item ${dropdownPrefixCls}-menu-item-multiple`}>
                                <Checkbox checked={filteredArr.every(item => selectedKeys.includes(item.value))} indeterminate={!filteredArr.every(item => selectedKeys.includes(item.value))
                                && filteredArr.some(item => selectedKeys.includes(item.value))} onChange={onCheckAll}>{locale.filterCheckall}</Checkbox>
                            </div>)}
                            {filteredArr.map((filter, index) => (<div key={index} 
                    // eslint-disable-next-line max-len
                    className={`${dropdownPrefixCls}-menu-item ${dropdownPrefixCls}-menu-item-multiple`}>
                                        <Checkbox checked={selectedKeys.includes(filter.value)} onChange={e => menuChange(e, filter.value)}>
                                            {searchValue ? formatContent(filter.text, searchValue, prefixCls) : filter.text}
                                        </Checkbox>
                                    </div>))}
                        </>}
                        {!filterMultiple && <>
                            {filterShowSelectAll
                        && (<div className={classNames(`${dropdownPrefixCls}-menu-item`, `${dropdownPrefixCls}-menu-item-all`)} onClick={onClearAll}>
                                {locale.filterAll}
                            </div>)}
                            {filteredArr.map((filter, index) => (<div className={classNames(`${dropdownPrefixCls}-menu-item`, 
                        // eslint-disable-next-line max-len
                        { [`${prefixCls}-dropdown-menu-item-checked`]: selectedKeys.includes(filter.value) })} key={index} onClick={() => onSingleCheck(filter.value)}>
                                        <span>
                                            {searchValue ? formatContent(filter.text, searchValue, prefixCls) : filter.text}
                                        </span>
                                    </div>))}
                        </>}
                    </div>
                </>);
        };
        dropdownContent = (<>
                {filterMode === 'menu' && <FilterSearch filterSearch={filterSearch} filterPlaceholder={filterPlaceholder} value={searchValue} onChange={onSearch} tablePrefixCls={tablePrefixCls} locale={locale}/>}
                {getFilterComponent()}
                {filterMultiple && (<div className={`${prefixCls}-dropdown-btns`}>
                    <Button type="primary" size="small" onClick={onConfirm}>
                        {locale.filterConfirm}
                    </Button>
                    <Button type="default" size="small" className={`${prefixCls}-dropdown-btns-reset`} onClick={onReset}>
                        {locale.filterReset}
                    </Button>
                </div>)}
            </>);
    }
    const menu = (<FilterDropdownMenuWrapper className={`${prefixCls}-dropdown-box`}>
            {dropdownContent}
        </FilterDropdownMenuWrapper>);
    let filterIcon;
    if (typeof column.filterIcon === 'function') {
        filterIcon = column.filterIcon(filtered);
    }
    else if (column.filterIcon) {
        filterIcon = column.filterIcon;
    }
    else {
        filterIcon = <OutlinedFunnel />;
    }
    const { direction } = React.useContext(ConfigContext);
    return (<div className={`${prefixCls}-column`}>
            <span className={`${tablePrefixCls}-column-title`}>{children}</span>
            <Dropdown overlay={menu} trigger={['click']} visible={mergedVisible} onVisibleChange={onVisibleChange} getPopupContainer={getPopupContainer} overlayClassName={`${prefixCls}-dropdown`} placement={direction === 'rtl' ? 'bottomRight' : 'bottomLeft'} onClick={e => e.stopPropagation()}>
                <span role="button" tabIndex={-1} className={classNames(`${prefixCls}-trigger`, {
            [`${prefixCls}-trigger-active`]: filtered
        })}>
                    {filterIcon}
                </span>
            </Dropdown>
        </div>);
}
export default FilterDropdown;
